import { offers } from "./offers";
import { moneyPages } from "../content/moneyPages";
import { renderFoxmarkLandingPage } from "../pages/foxmarkLandingPage";
import { renderMoneyPage } from "../pages/moneyPage";
import { renderIntakeHandoffPage } from "../pages/intakeHandoffPage";
import { verticalRoutes } from "../pages/verticalPages";
import { guideRoutes } from "../pages/guidePages";
import type { PageRoute } from "../seo/document";
import {
  breadcrumbNode,
  faqPageNode,
  graph,
  organizationNode,
  serviceNode,
  websiteNode
} from "../seo/schema";

const homeRoute: PageRoute = {
  path: "/",
  title: "Monthly Reputation & Website Reports for Local Businesses | Foxmark",
  description:
    "Foxmark gives local businesses done-for-you Google review & reputation management and monthly website audits for a flat $149/month. No contracts, cancel anytime.",
  indexable: true,
  jsonLd: graph([
    organizationNode,
    websiteNode,
    serviceNode({
      name: "Foxmark Local Trust Pack",
      serviceType: "Online reputation and Google Business Profile management",
      path: "/google-review-management",
      description: offers[0].summary
    }),
    serviceNode({
      name: "Foxmark Site Leak Report",
      serviceType: "Website conversion audit",
      path: "/website-audit-service",
      description: offers[1].summary
    })
  ]),
  render: () => renderFoxmarkLandingPage()
};

const moneyRoutes: PageRoute[] = moneyPages.map((content) => {
  const offer = offers.find((candidate) => candidate.id === content.offerId);
  if (!offer) {
    throw new Error(`Money page references unknown offer: ${content.offerId}`);
  }

  return {
    path: offer.pagePath,
    title: content.seoTitle,
    description: content.seoDescription,
    indexable: true,
    jsonLd: graph([
      serviceNode({
        name: offer.name,
        serviceType: content.serviceType,
        path: offer.pagePath,
        description: offer.summary
      }),
      breadcrumbNode([
        { name: "Foxmark", path: "/" },
        { name: offer.cardName, path: offer.pagePath }
      ]),
      faqPageNode(content.faqs)
    ]),
    render: (assetBase: string) => renderMoneyPage(offer, content, assetBase)
  };
});

const intakeRoutes: PageRoute[] = offers.map((offer) => ({
  path: offer.postPaymentPath,
  title: `Finish your ${offer.name} intake | Foxmark`,
  description: `Complete your ${offer.name} intake so Foxmark can prepare your first monthly pack.`,
  indexable: false,
  jsonLd: graph([organizationNode]),
  render: () => renderIntakeHandoffPage(offer)
}));

export const routes: PageRoute[] = [
  homeRoute,
  ...moneyRoutes,
  ...verticalRoutes,
  ...guideRoutes,
  ...intakeRoutes
];

export function findRoute(path: string): PageRoute | undefined {
  return routes.find((route) => route.path === path);
}
